// 권한 관련 notion https://www.notion.so/barogohq/7828d33d527647faad316ffa62c6d920?v=e2c5f2d7dd0d48049d13ee1d4ccc60c8
import { swap } from '@/utils/swap';
// [권한의 이름]
// 관리자CS권한 이름도 같이 기재 필요. 아직은 명칭 혼용되는 중
// 권한 이름 패턴
// 허컨권한 이름 (관리자cs권한 이름)
// 예시)
// 라이더권한 (기사권한)
// [권한의 구조]
// 유저권한은 총 7자리로 이루어짐
// 예시) 1307011
// 앞 6자리(130701)가 기능에 대한 분류
// 마지막 자리가 1, 0으로 권한의 가, 불가를 구분함.
// ex)
// 1307011은 타허브선택권한이 있음.
// 1307010은 타허브선택권한이 없음.
// [권한 여부]
// 가, 불가에 대한 약어
// P => Permission
// N => No Permission
// [권한 상수 명칭 컨벤션]
// 결과적으로 뭘 하려는지 CRUD 측면으로 고민해서 작성
// C >> CREATE_xxx, POST_xxx
// R >> GET_xxx
// U >> UPDATE_xxx, EDIT_xxx
// D >> DELETE_xxx
// 단순 실행 >> 위 항목으로 표현이 어려울 때 EXECUTE
// [권한의 조합]
// 관리자CS가 지원하지 않는 권한은 조합해서 만든다. 예) 허브 조회 권한
// 모바일권한(관리자앱관리) 권한과 잘 분리해서 진행 되어야 한다. 요주의
// 프론트엔드 테스트를 위한 임시 권한
const temporary = {
    // 임시 페이지 접근 권한 (테스트용)
    P_GET_TEMPORARY: '9999991',
    N_GET_TEMP: '9999990',
    // 임시 2 (테스트용)
    P_GET_TEMPORARY2: '9999981',
    N_GET_TEMP2: '9999980',
};
// 공유 관리
const shareManagement = {
    // 총판 & 본사내 사용자만 페이지 접근 가능
    // 공유 조회 === P_VIEW_SHARE_MANAGEMENT || P_CONFIG_SHARE_MANAGEMENT
    // 공유 수정 === P_VIEW_SHARE_MANAGEMENT && P_CONFIG_SHARE_MANAGEMENT
    P_GET_SHARE_MANAGEMENT() {
        return [
            this.P_VIEW_SHARE_MANAGEMENT,
            this.P_CONFIG_SHARE_MANAGEMENT,
        ];
    },
    // 공유 정보 조회
    P_VIEW_SHARE_MANAGEMENT: '0302011',
    N_VIEW_SHARE_MANAGEMENT: '0302010',
    // 공유 정보 수정
    P_CONFIG_SHARE_MANAGEMENT: '0302021',
    N_CONFIG_SHARE_MANAGEMENT: '0302020',
};
// 허브 관리 (지사 관리)
const hubManagement = {
    // 허브 조회 === 허브 관리 메뉴 노출 여부
    P_GET_HUB() {
        return [
            this.P_CREATE_HUB,
            this.P_EDIT_HUB,
        ];
    },
    // 허브 등록
    P_CREATE_HUB: '0301011',
    N_CREATE_HUB: '0301010',
    // 허브 수정
    P_EDIT_HUB: '0301021',
    N_EDIT_HUB: '0301020',
};
// 라이더 관리 (기사 관리)
const workerManagement = {
    // 라이더 조회 === 라이더 관리 메뉴 노출 여부
    P_GET_WORKER() {
        return [
            this.P_EDIT_REMITTANCE_BAROMONEY,
            this.P_CREATE_WORKER,
            this.P_EDIT_WORKER,
            this.P_FEE_GROUP,
            this.P_EDIT_BAROMONEY_SETTING,
        ];
    },
    // 라이더 수수료그룹설정 (배달대행수수료그룹 설정)
    P_FEE_GROUP: '0401041',
    // 라이더 등록 (기사등록)
    P_CREATE_WORKER: '0401021',
    // 라이더 정보 수정 (기사수정)
    P_EDIT_WORKER: '0401031',
    // 라이더 평가 조회 (기사평가내역)
    P_GET_WORKER_ASSES: '0401081',
    // 라이더 바로머니 보정 (기사캐쉬충)
    P_EDIT_REMITTANCE_BAROMONEY: '0401011',
    // 라이더 목록 다운로드 (엑셀다운)
    P_EXECUTE_WORKER_EXCEL_DOWNLOAD: '0401071',
    // 라이더 바로머니 정기공제 설정 (자동캐쉬차감그룹 설정)
    P_EDIT_BAROMONEY_SETTING: '0401061',
};
// 상점 관리
const storeManagement = {
    P_GET_STORE() {
        return [
            this.P_EDIT_STORE_STATE,
            this.P_EXECUTE_STORE_CONFIG_COPY,
            this.P_EDIT_DELIVERY_FEE,
            this.P_EXECUTE_BAROMONEY_REMIT,
            this.P_EDIT_STORE_MANAGEMENT_FEE,
            this.P_EXECUTE_STORE_EXCEL_DOWNLOAD,
            this.P_CREATE_STORE,
            this.P_EDIT_GOODS_PRICE_SERCHARGE,
        ];
    },
    // 상점 상태 수정 (가맹점수정참/가맹점상태 수정)
    P_EDIT_STORE_STATE: '0303101',
    // 상점 설정 복사 (가맹점 설정복사)
    P_EXECUTE_STORE_CONFIG_COPY: '0303111',
    // 배달대행료설정 수정 / 배달대행료 설정 (가맹점수정창)
    P_EDIT_DELIVERY_FEE: '0303131',
    // 상점 바로머니 송금 (가맹점 송금)
    P_EXECUTE_BAROMONEY_REMIT: '0303131',
    // 상점 관리비 설정 (가맹점수정창 / 가맹비설정 수정)
    P_EDIT_STORE_MANAGEMENT_FEE: '0303031',
    // 엑셀다운 (상점 목록 다운로드)
    P_EXECUTE_STORE_EXCEL_DOWNLOAD: '0303121',
    // 상점 등록 (가맹점등록)
    P_CREATE_STORE: '0303011',
    // 상품가할증 설정 (가맹점수정창 / 할증요금설정 수정)
    P_EDIT_GOODS_PRICE_SERCHARGE: '0303061',
};
const userManagement = {
    P_GET_USER_LIST() {
        return [
            this.P_CREATE_USER,
            this.P_EDIT_USER,
        ];
    },
    // 사용자 관리 등록
    P_CREATE_USER: '0501011',
    N_CREATE_USER: '0501010',
    // 사용자 관리 수정
    P_EDIT_USER: '0501021',
    N_EDIT_USER: '0501020',
    // 사용자 권한
    P_UPDATE_USER_PERMISSION: '0502011',
    N_UPDATE_USER_PERMISSION: '0502010',
};
const hubAdjustment = {
    P_POST_TAX_INVOICE() {
        return [
            this.P_GET_HUB_ADJUSTMENT,
            this.P_POST_INTER_HUB_ADJUSTMENT,
            this.P_GET_DETAIL_HISTORY,
            this.P_POST_WITHDRAW_HUB_BAROMONEY,
        ];
    },
    // 매출 > 매출열람 > 허브매출열람
    P_GET_HUB_ADJUSTMENT: '0804021',
    N_GET_HUB_ADJUSTMENT: '0804020',
    // 정산 > 회사간정산 (주체별정산)
    P_POST_INTER_HUB_ADJUSTMENT: '0901011',
    N_POST_INTER_HUB_ADJUSTMENT: '0901010',
    // 정산 > 세부내역보기
    P_GET_DETAIL_HISTORY: '0902011',
    N_GET_DETAIL_HISTORY: '0902010',
    // 정산 > 지사캐쉬출금
    P_POST_WITHDRAW_HUB_BAROMONEY: '0902021',
    N_POST_WITHDRAW_HUB_BAROMONEY: '0902020',
};
/** 통계 */
const stats = {
    P_GET_STORE_STATS: '1003011',
    N_GET_STORE_STATS: '1003010',
    P_GET_HUB_STATS: '1003021',
    N_GET_HUB_STATS: '1003020',
};
const permissionList = {
    // 상점정산 페이지 조회
    P_GET_STORE_ADJUSTMENT: '0804011',
    N_GET_STORE_ADJUSTMENT: '0804010',
    // 타허브 선택 권한
    P_GET_OTHER_HUB: '1307011',
    N_GET_OTHER_HUB: '1307010',
    // 배달 결제금액 수정
    P_EDIT_ORDER_AMOUNT: '1301011',
    N_EDIT_ORDER_AMOUNT: '1301010',
    // 배달 대행료 수정
    P_EDIT_DELIVERY_AMOUNT: '1301021',
    N_EDIT_DELIVERY_AMOUNT: '1301020',
    // 상점 바로머니 송금 (to.상점)
    P_REMITTANCE_BAROMONEY_TO_STORE: '1301031',
    N_REMITTANCE_BAROMONEY_TO_STORE: '1301030',
    // 배차 기능 사용 여부
    P_EXECUTE_ALLOCATE_WORKER: '1302011',
    N_EXECUTE_ALLOCATE_WORKER: '1302010',
    // 추가할증 설정
    P_EDIT_IRREGULAR_SURCHARGE: '1305011',
    N_EDIT_IRREGULAR_SURCHARGE: '1305010',
    // 타허브 관제 및 운행설정
    // P_EDIT_IRREGULAR_SURCHARGE: '130501',
    // N_EDIT_IRREGULAR_SURCHARGE: '130500',
    // 배달 바로머니 송금
    P_REMITTANCE_BAROMONEY: '0201101',
    N_REMITTANCE_BAROMONEY: '0201100',
    // 매출열람전체허용
    P_GET_SALES_ALL: '0804001',
    N_GET_SALES_ALL: '0804010',
    // 허브매출열람, 바로머니 리포트 매출조회
    P_GET_HUB_SALES: '0804021',
    N_GET_HUB_SALES: '0804020',
    // 대행료 수정
    P_EDIT_DELIVERY_CHARGE: '0202011',
    N_EDIT_DELIVERY_CHARGE: '0202010',
    // 라이더정산 조회
    P_GET_WORKER_ADJUSTMENT: '1304021',
    N_GET_WORKER_ADJUSTMENT: '1304020',
    // 라이더 지원금 (기사지원금 입력/수정)
    P_UPDATE_WORKER_SUPPORT_AMOUNT: '0202021',
    N_UPDATE_WORKER_SUPPORT_AMOUNT: '0202020',
    ...temporary,
    ...hubManagement,
    ...workerManagement,
    ...storeManagement,
    ...userManagement,
    ...shareManagement,
    ...hubAdjustment,
    ...stats,
};
const getSwapKeyValue = () => (
// TODO 묶음 권한 이슈로 해결 필요
swap(permissionList));
export const userPermissionListSwapKeyValue = getSwapKeyValue();
export default permissionList;
/** 사용자 권한 전체 허용 */
export const USER_PERMISSION_SETTING = '050200';
/** 사용자 권한 */
export const UPDATE_USER_PERMISSION = '050201';
